import FlyDirect from "./FlyDirect.js";
import {descend} from "../planeSlice.js";
import {getDistance} from "../../assets/virtual-flyout/nav-calc.js";
import {STANDARD_VS_DESCENT} from "../../assets/virtual-flyout/perf-calc.js";

export default class FlyDirectDescend extends FlyDirect {
    constructor(planeId, waypoint, altitude) {
        super(planeId, waypoint);
        this.altitude = altitude;
    }

    isComplete() {
        const planeState = this.getState();
        const altDiff = planeState.altitude - this.altitude;
        const timeToDescend = altDiff / Math.abs(STANDARD_VS_DESCENT) * 60;
        const distanceToWp = getDistance(planeState.coordinates, this.waypoint);
        const timeToWp = distanceToWp / planeState.gs * 3600;
        if (timeToWp <= timeToDescend && planeState.vs >= 0) {
            this.log(`Descending to ${this.altitude}ft`);
            this.dispatch(descend({altitude: this.altitude}));
        }
        return super.isComplete();
    }
}
